import { RewardTypeEnum } from "@/types/reward";

export function isVipReward({ type }: { type: RewardTypeEnum; }) {
  return [RewardTypeEnum.PROMOTION_REWARD, RewardTypeEnum.CASH_BACK, RewardTypeEnum.DAILY_REWARD, RewardTypeEnum.MONTHLY_REWARD, RewardTypeEnum.WEEKLY_REWARD].includes(type);
}

export const RewardTypeHelper = {
  isVipReward,
};